import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Draggable from 'react-draggable';
import './FloatingAlarmTab.css';
import Assembly from './sound/assembly.mp3';
import Break from './sound/break.mp3';
import Breakover from './sound/over.mp3';
import Change from './sound/change.mp3';
import Change2 from './sound/change2.mp3';
import Brahms from './sound/brahmsx27-lullaby-160672.mp3';
import Calm from './sound/calm-and-peaceful-115481.mp3';
import Closing from './sound/closing.mp3';
import Lunch from './sound/lunch.mp3';
import Twinkle from './sound/twinkle-like-a-star-8026.mp3';
import Madieval from './sound/medieval-star-188280.mp3';
import Lunchover from './sound/lunchover.mp3';
import Storybook from './sound/lullaby-storybook-2-317191.mp3';
import Sleep from './sound/lullaby-sleep-piano-music-285599.mp3';
import Fairies from './sound/lullaby-fairies-315868.mp3';
import Baby from './sound/lullaby-baby-sleep-dreams-celestial-music-297507.mp3';
import Legacy from './sound/legacy-of-brahms-lullaby-background-orchestral-music-for-video-full-274550.mp3';
import Deck from './sound/deck-the-halls-background-christmas-music-for-video-calesta-version-253224.mp3';
import NSMQs from './sound/NSMQ.mp3';
import Breaklower from './sound/breaklower.mp3';
import Breakupper from './sound/breakupper.mp3';
import Breakjhs from './sound/breakjhs.mp3';
import Changelessonjhs from './sound/changelessonjhs.mp3';
import Changelessonlower from './sound/changelessonlower.mp3';
import Changelessonupper from './sound/changelessonupper.mp3';
import Lunchjhs from './sound/lunchjhs.mp3';
import Lunchlower from './sound/lunchlower.mp3';
import Lunchupper from './sound/lunchupper.mp3';
import Startlesson from './sound/startlesson.mp3';
import Silencehour from './sound/silencehour.mp3';
import Remedial from './sound/remedial.mp3';



const Alarmlist = [
  { type: "assembly", alarm: Assembly },
  { type: "break", alarm: Break },
  { type: "breakover", alarm: Breakover },
  { type: "change", alarm: Change },
  { type: "change2", alarm: Change2 },
  { type: "brahms", alarm: Brahms },
  { type: "calm", alarm: Calm },
  { type: "closing", alarm: Closing },
  { type: "lunch", alarm: Lunch },
  { type: "twinkle", alarm: Twinkle },
  { type: "madieval", alarm: Madieval },
  { type: "lunchover", alarm: Lunchover },
  { type: "storybook", alarm: Storybook },
  { type: "sleep", alarm: Sleep },
  { type: "fairies", alarm: Fairies },
  { type: "baby", alarm: Baby },
  { type: "legacy", alarm: Legacy },
  { type: "deck", alarm: Deck },
  { type: "NSMQ", alarm: NSMQs },
  { type: "breaklower", alarm: Breaklower },
  { type: "breakupper", alarm: Breakupper },
  { type: "breakjhs", alarm: Breakjhs },
  { type: "changelessonjhs", alarm: Changelessonjhs },
  { type: "changelessonlower", alarm: Changelessonlower },
  { type: "changelessonupper", alarm: Changelessonupper },
  { type: "lunchjhs", alarm: Lunchjhs },
  { type: "lunchlower", alarm: Lunchlower },
  { type: "lunchupper", alarm: Lunchupper },
  { type: "startlesson", alarm: Startlesson },
  { type: "silencehour", alarm: Silencehour },
  { type: "remedial", alarm: Remedial },
  // Add missing sound types that are used in the form
  { type: "bell", alarm: Change },
  { type: "chime", alarm: Twinkle },
  { type: "gong", alarm: Closing },
  { type: "whistle", alarm: Break },
];

const AlarmClock = () => {
  const schooldetails_ = useSelector((state) => state.schooldetails);
  const alarms = schooldetails_[0] && schooldetails_[0].siren ? schooldetails_[0].siren : [];
  
  // Debug logging for alarm data

  const [currentTime, setCurrentTime] = useState(new Date());
  const [nextAlarm, setNextAlarm] = useState(null);
  const [countdown, setCountdown] = useState('');
  const [isMinimized, setIsMinimized] = useState(true);
  const [isFirstAudioPlaying, setIsFirstAudioPlaying] = useState(false);
  const [isSecondAudioPlaying, setIsSecondAudioPlaying] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [isCountdownActive, setIsCountdownActive] = useState(true);
  const audioRef = useRef(null);
  const panelRef = useRef(null);

  // Parse time string to Date object
  const parseTimeToDate = (timeStr, baseDate) => {
    // Handle both 24-hour format (08:00) and 12-hour format (08:00 AM)
    if (timeStr.includes(' ')) {
      // 12-hour format with AM/PM
      const [time, period] = timeStr.split(' ');
      let [hours, minutes] = time.split(':').map(Number);
      if (period === 'PM' && hours !== 12) hours += 12;
      if (period === 'AM' && hours === 12) hours = 0;
      const date = new Date(baseDate);
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      return date;
    } else {
      // 24-hour format (08:00)
      const [hours, minutes] = timeStr.split(':').map(Number);
      const date = new Date(baseDate);
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      return date;
    }
  };

  // Find the next alarm for the current day
  const findNextAlarm = (alarms) => {
    const today = currentTime.toLocaleString('en-US', { weekday: 'long' });
    const now = currentTime.getTime();
    

    // Validate alarm data structure
    const validAlarms = alarms.filter(alarm => {
      const isValid = alarm && 
                     typeof alarm === 'object' && 
                     Array.isArray(alarm.days) && 
                     alarm.days.length > 0 &&
                     alarm.time &&
                     alarm.isActive !== false;
      
      if (!isValid) {
        console.warn('⚠️ Invalid alarm data:', alarm);
      }
      return isValid;
    });


    const todayAlarms = validAlarms.filter(alarm => {
      const hasToday = alarm.days.includes(today);
      return hasToday;
    });

    if (todayAlarms.length === 0) {
      return null;
    }

    const futureAlarms = todayAlarms
      .map(alarm => {
        try {
          const alarmTime = parseTimeToDate(alarm.time, currentTime).getTime();
          const isFuture = alarmTime > now;
          return {
            ...alarm,
            alarmTime,
          };
        } catch (error) {
          console.error('❌ Error parsing alarm time:', alarm.time, error);
          return null;
        }
      })
      .filter(alarm => alarm && alarm.alarmTime > now)
      .sort((a, b) => a.alarmTime - b.alarmTime);

    const nextAlarm = futureAlarms.length > 0 ? futureAlarms[0] : null;

    return nextAlarm;
  };

  // Play alarm sound (first audio for 10s, then second audio)
  const playAlarmSound = (alarm = nextAlarm) => {
    // Check if alarm exists before proceeding
    if (!alarm) {
      return;
    }

    // Prevent duplicate calls - check if already triggered or audio is playing
    if (hasTriggered || isFirstAudioPlaying || isSecondAudioPlaying) {
      return;
    }


    // Stop any existing audio before starting new playback
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setIsCountdownActive(false); // Pause countdown during audio playback
    setHasTriggered(true); // Mark alarm as triggered

    // Get audio files from Alarmlist - ensure they are different
    const firstAudioSrc = Alarmlist.find(bug => bug.type === alarm.sound)?.alarm || Deck;
    let secondAudioSrc = Alarmlist.find(bug => bug.type === alarm.type)?.alarm || Deck;
    
    // Validate audio sources
    if (!firstAudioSrc) {
      console.error('❌ First audio source not found for type:', alarm.sound);
      return;
    }
    
    if (!secondAudioSrc) {
      console.error('❌ Second audio source not found for type:', alarm.type);
      return;
    }
    
    // If both audios are the same, use a different default for second audio
    if (firstAudioSrc === secondAudioSrc) {
      const alternativeSounds = ['change', 'twinkle', 'closing', 'break'];
      for (const soundType of alternativeSounds) {
        const altSrc = Alarmlist.find(bug => bug.type === soundType)?.alarm;
        if (altSrc && altSrc !== firstAudioSrc) {
          secondAudioSrc = altSrc;
          break;
        }
      }
    }


    const firstAudio = new Audio(firstAudioSrc);
    const secondAudio = new Audio(secondAudioSrc);
    audioRef.current = firstAudio;

    // Play first audio
    setIsFirstAudioPlaying(true);
    firstAudio.play().catch(error => {
      if (error.name !== 'AbortError') {
        console.error('❌ Error playing first audio:', error);
      }
      setIsFirstAudioPlaying(false);
      setIsCountdownActive(true); // Resume countdown on error
      setHasTriggered(false); // Allow retry on error
    });

    // After 20 seconds, stop first audio and play second audio
    const timer = setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      setIsFirstAudioPlaying(false);
      setIsSecondAudioPlaying(true);

      audioRef.current = secondAudio;
      secondAudio.play().catch(error => {
        if (error.name !== 'AbortError') {
          console.error('❌ Error playing second audio:', error);
        }
        setIsSecondAudioPlaying(false);
        setIsCountdownActive(true); // Resume countdown on error
        setHasTriggered(false); // Allow retry on error
      });

      // When second audio ends, resume countdown
      secondAudio.onended = () => {
        setIsSecondAudioPlaying(false);
        setIsCountdownActive(true);
        // Reset hasTriggered after a delay to prevent immediate retriggering
        setTimeout(() => {
          setHasTriggered(false);
        }, 2000); // 2 second delay before allowing next alarm
      };
    }, 20000); // 20 seconds for first audio

    // Cleanup on component unmount or audio interruption
    return () => {
      clearTimeout(timer);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  };

  // Update countdown and trigger alarm
  useEffect(() => {
    if (!isCountdownActive) return;

    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime(now);

      const next = findNextAlarm(alarms);
      setNextAlarm(next);

      if (next) {
        const timeDiff = next.alarmTime - now.getTime();
        if (timeDiff <= 1000 && !hasTriggered) { // Trigger within 1 second and not already triggered
          playAlarmSound(next);
          setCountdown('Alarm triggered!');
        } else {
          const hours = Math.floor(timeDiff / (1000 * 60 * 60));
          const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
          setCountdown(`${hours}h ${minutes}m ${seconds}s`);
        }
      } else {
        setCountdown('No alarms for today.');
        setHasTriggered(false); // Reset for next day
      }
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [alarms, isCountdownActive, hasTriggered]);

  // Cleanup audio on component unmount
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  return (
    <>
      {nextAlarm !== null && (
        <Draggable
          handle=".panel-header"
          defaultPosition={{ x: 0, y: 0 }}
          bounds="parent"
        >
          <div
            ref={panelRef}
            className={`floating-panel ${isMinimized ? 'minimized' : ''}`}
            style={{ backgroundImage: "linear-gradient(315deg, #17dddd 0%, #1760d3 74%)" }}
          >
            <div className="panel-header">
              <div className="panel-title">Next Siren ({nextAlarm.name}: {countdown})</div>
              <div className="panel-controls">
                <button onClick={toggleMinimize} className="minimize-btn">
                  {isMinimized ? '+' : '−'}
                </button>
              </div>
            </div>
            <div className="panel-content">
              <div className="content-wrapper">
                <h3>{nextAlarm.name}</h3>
                <p><strong>Current Time:</strong> {currentTime.toLocaleTimeString()}</p>
                <p><strong>Next Alarm Time:</strong> {nextAlarm.time}</p>
                <p><strong>Status:</strong> {nextAlarm.isActive ? 'Active' : 'Inactive'}</p>
              </div>
            </div>
          </div>
        </Draggable>
      )}
      {/* {!soundEnabled && (
        <button onClick={() => setSoundEnabled(true)}>
          Enable Alarm Sound
        </button>
      )} */}
    </>
  );
};

export default AlarmClock;